import createDebug from 'debug';
import { SpotifyTransport } from 'spotify-transport';
import { Event } from 'spotify-transport/types';
import EventSender from 'spotify-event-sender/event_sender';
import createClientId from 'spotify-event-definitions/contexts/createClientId';
import createUserAgent from 'spotify-event-definitions/contexts/createUserAgent';

const debug = createDebug('gabito:logger');

type Options = {
  transport: SpotifyTransport;
  clientId: string;
};

export type GabitoEvent = {
  name: string;
  data: {
    [key: string]: string | number | boolean;
  };
};

export function createGabitoLogger({ transport, clientId }: Options) {
  const clientIdContext = () =>
    createClientId({
      value: clientId,
    });

  const userAgentContext = () =>
    createUserAgent({
      value: window.navigator.userAgent,
    });

  const logger = EventSender.create({
    transport,
    context: [clientIdContext, userAgentContext],
  });

  return function logGabitoEvent(event: GabitoEvent) {
    debug(event);
    logger.log(event);
  };
}

export function createAuthenticatedGabitoLogger(options: Options) {
  const { transport } = options;

  const authenticated = new Promise(resolve => {
    transport.on(Event.TRANSPORT_AUTHENTICATED, resolve);
  });

  const logGabitoEvent = createGabitoLogger(options);

  return function logAuthenticatedGabitoEvent(event: GabitoEvent) {
    authenticated.then(() => {
      logGabitoEvent(event);
    });
  };
}
